import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { removeProduct, updateProduct } from '../../actions/product';
import { DASHBOARD } from '../Routes/routes';

const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: 345,
    margin: theme.spacing(1),
  },
  link: {
    textDecoration: 'none',
    color: '#3f51b5',
  },
}));

const ProductCard = props => {
  const { product } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <Card className={classes.card}>
        <Link className={classes.link} to={`${DASHBOARD}/${product.productBox}/${product.id}/edit`}>
          <CardActionArea>
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                {product.name}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                Art: {product.art}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                Alder: {product.age}
              </Typography>
              <Typography component="p">
              <u>Størrelse:</u> {product.size}
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
                Proveniens: {product.proveniens}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                Antal: {product.amount}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                Kasse: {product.productBox}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                Oprettede:
                {moment(product.createdAt.toDate()).format(
                  'dddd, MMMM Do YYYY, h:mm a',
                )}
              </Typography>
              {product.updatedAt && (
                <Typography variant="body2" color="textSecondary" component="p">
                  Opdateret:
                  {moment(product.updatedAt.toDate()).format(
                    'dddd, MMMM Do YYYY, h:mm a',
                  )}
                </Typography>
              )}
            </CardContent>
          </CardActionArea>
        </Link>
      </Card>
    </React.Fragment>
  );
};

export default connect(
  null,
  { removeProduct, updateProduct },
)(ProductCard);
